import React from 'react';
import PropTypes from 'prop-types';
import TrackVisibility from 'react-on-screen';
import imageSets from '../../services/reponsive-image-manager';

export default class Picture extends React.Component
{
    constructor(props) {
        super(props);

        let sources = [];
        let srcSet = [];
        let sizeSet = [];
        let imageSet = imageSets.findImageSet(this.props.filter);

        if (this.props.src) {
            imageSet.sizes.map((size, index) => {
                let media = size.media_queries.map((mediaQuery) => {
                    return imageSets.translateMediaQuery(mediaQuery);
                }).join(' AND ');
                srcSet.push(imageSets.resolvePath(this.props.filter, size.width, this.props.src));
                sizeSet.push(media + ' ' + size.width + 'px');
                sources.push({
                    size: size,
                    key: index,
                    src: imageSets.resolvePath(this.props.filter, size.width, this.props.src.split(/\.(?=[^\.]+$)/)[0] + '.webp'),
                    media: media,
                    type: "image/webp"
                });
            });

            this.state = {
                srcSet: srcSet.slice(0).reverse().join(', '),
                sizeSet: sizeSet.slice(0).reverse().join(', '),
                sources: sources,
                defaultSrc: imageSets.createDefaultSrcAttr(imageSet.name, this.props.src)
            };
        }
    }

    isSVG = () => {
        if(this.props.src) return this.props.src.split('.')[1] === 'svg';
        return null;
    }

    render(){
        if(!this.props.src) return (
            <></>
        )

        if(this.isSVG()){
            return <img onLoad={ this.props.onFinishedLoad }  className={this.props.className}  src={this.props.src} alt={this.props.alt}/>
        }

        return (
            <TrackVisibility offset={350} tag="picture" className={this.props.className} once>
                {({ isVisible }) => {
                    return <>
                        {isVisible && this.state.sources.slice(0).map((source) => <source
                            key={source.key}
                            srcSet={source.src}
                            media={source.media}
                            type="image/webp"
                            className="sharpen"
                        />)}

                        <img
                            onLoad={ this.props.onFinishedLoad }
                            src={imageSets.resolvePath('blur', '30', this.props.src)}
                            alt={this.props.alt || ''}
                            title={this.props.title || ''}
                        />
                    </>
                }}
            </TrackVisibility>
        )
    }
}

Picture.defaultProps = {
    'onFinishedLoad': () => {},
    'title': null,
    'className': '',
    'lazyLoad': true,
    'filter': 'default'
};
